module.exports = __webpack_public_path__ + "51521a2a8da71e50d871ac6fd2187e87.woff2";